module.exports = __WEBPACK_EXTERNAL_MODULE_video_js__;